module.exports = __webpack_public_path__ + "img/qchz.363b7105.png";